<template lang="pug">
.validate(v-if="(job.status === 'Atendimento encerrado' || job.status === 'Validado com sucesso') && perfis.indexOf(user.grupo) > -1")
    Button(layout="green-go" @click="modal.show = true" :loader="loader")
      i.fa.fa-check 
      | VALIDAR
    Modal(:modal="modal")
      .form
        .row.wp.js.col-s
          .col
            label Cliente
            b {{job.nome_cliente}}
          .col
            label Forma atendimento
            b {{job.forma_atendimento}}
          .col
            label Supporter
            b {{ job.nome_doutor }}
          .col
            label Duração
            b {{ job.at_duracao_atendimento }}
        .row.js.col-s
          .col.g5.g12-s
            label Problema
            b(v-html="job.problema.replace(/\\n/g, '<br />')")
          .col.g5.g12-s
            label Relatório de Atividade Técnica - RAT
            b(v-html="job.descricao_atendimento.replace(/\\n/g, '<br />')")
            label Arquivos anexados
            a(v-for="arquivo in job.arquivos" :href="arquivo.link" target="_blank") {{arquivo.nome}}
       
        .invalidate.row.ae.col-s
          .col.g12-s
            label Atendimento improdutivo
            select(v-model="id_atendimento_improdutivo")
              option(value="") Selecione
              option(v-for="flag of flags" :value="flag.id") {{ flag.flag }}
          .g12
            label Motivo falha validação
            input(v-model="motivo_falha_validacao" placeholder="Motivo falha validação")
        .alert.mt(v-if="extra")
          b ATENÇÃO!!!
          |  A duração informada é maior que o atendimento estimado ({{job.criterios_encerramento.duracao_atendimento}}h). Horas extras são permitidas somente com autorização prévia. Se você foi autorizado a fazer horas adicionais você pode manter o valor informado, se você não foi autorizado há grande chance deste valor ser rejeitado na validação do atendimento. Toda hora extra deve ser autorizada antes de ser executada e é sujeita a aprovação.
        .controls.row.ja.col-s
          Button(type="button" :loader="loader" layout="green-go" icon="fa fa-check" @click="validate")
            i.fa.fa-check
            | VALIDAR
          Button(type="button" @click="invalidate" :loader="loader" layout="red-go")
            i.fa.fa-trash 
            | INVALIDAR
</template>

<script>
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Validate",
  components: { Button, Modal },
  props: { job: Object, cb: Function },
  data() {
    return {
      extra: false,
      perfis: ['Financeiro', 'Gestor de Demanda', 'Gestor de Device', 'Gestor de Infra', 'TI', 'Gestor de Operação', 'Diretor de Operação'],
      loader: false,
      id_atendimento_improdutivo: "",
      motivo_falha_validacao: "",
      modal: { title: "Validação de Atendimento do Job: " + this.job.id, show: false },
      flags: []
    };
  },
  beforeMount() {
    let duracao = parseInt(this.job.at_duracao_atendimento.replace(":", ""))
    let criterios = parseInt(this.job.criterios_encerramento.duracao_atendimento.replace(":", ""))
    if (duracao > criterios) this.extra = true
  },
  mounted() {
    if (this.job.status === 'Atendimento encerrado' || this.job.status === 'Falha validação')
      this.FLAGS_LIST({ status: "ativo", filtro: "atendimento_improdutivo" }).then(({ data }) => (this.flags = data));
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
  methods: {
    ...mapActions("admin", ["FLAGS_LIST", "JOB_VALIDATE", "JOB_INVALIDATE"]),
    async validate() {
      this.loader = true;
      await this.JOB_VALIDATE({ id: this.job.id, finaliza: true, id_atendimento_improdutivo: null })
        .then(async () => { this.modal.show = false; })
      setTimeout(() => (this.cb(), this.loader = false), 3000)

    },
    async invalidate() {
      this.loader = true;
      await this.JOB_INVALIDATE({ id: this.job.id, id_atendimento_improdutivo: this.id_atendimento_improdutivo, motivo_falha_validacao: this.motivo_falha_validacao, finaliza: true })
        .then(() => this.modal.show = false)

      setTimeout(() => (this.cb(), this.loader = false), 3000)
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.validate
  .form
    max-width: 900px
    padding: 20px 30px
    padding-top: 0
    label
      @include label
      margin-top: 30px
    b
      font-size: 18px
    a
      margin-bottom: 10px
      font-size: 14px
    .controls
      margin-top: 50px
      @media(max-width: $small)
        button
          margin-bottom: 30px
          font-size: 18px
  .alert, .alert b
    background: $red
    font-size: 18px
    color: white
    padding: 12px
    border-radius: 12px
</style>
